import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListSubscriptions from '../../components/billing/list-subscriptions.component';

const BillingSubscriptionsView = () => {
  const pageTitle = 'User Management / Subscribers';

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListSubscriptions />
    </AppLayout>
  );
};

export default BillingSubscriptionsView;
